import Button from 'components/UIKit/Button'
import { useMutation } from '@apollo/client'
import { CANCEL_CFD_JOB_MUTATION } from 'client/mutations'
import { useParams } from 'react-router-dom'

const CancelCFDButton = buttonProps => {
  const { versionId } = useParams()
  const [cancelCFD, { loading, error }] = useMutation(CANCEL_CFD_JOB_MUTATION, {
    awaitRefetchQueries: true,
    onError(error) {
      console.error(error)
    },
    refetchQueries: ['GetCFDStatuses', 'GetCfdImageResults'],
  })

  const handleClick = () => {
    if (!versionId) return
    cancelCFD({ variables: { versionId } })
  }

  const buttonLabel = loading ? 'Cancelling...' : error ? 'Failed to Cancel CFD' : 'Cancel CFD Simulation'

  return <Button disabled={loading} label={buttonLabel} onClick={handleClick} {...buttonProps} />
}

export { CancelCFDButton }
